module.exports = __webpack_public_path__ + "assets/img/sex1.f8ccde8e.svg";